export default __webpack_public_path__ + "static/media/dosa.09cb38b4.png";